import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { SITE_DEFAULTS } from '../constants/siteDefaults';

const URL_MIGRATIONS: Record<string, Record<string, string>> = {
  "home": {
    "https://realta.b-cdn.net/Media/WO%20Level%201%20Doug%20Gordin%20Whitby%2C%20Ontario.mp4": "https://realta.b-cdn.net/Media/WO%20Level%201%20Doug%20Gordin%20Whitby%2C%20Ontariov2.mp4",
    "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON%20w%20captions%202_1_prob4.mp4": "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON_prob4v2.mp4",
    "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON.mp4": "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON_prob4v2.mp4",
    "https://realta.b-cdn.net/Media/Hero%20Section%20Video%20WO.mp4": "https://realta.b-cdn.net/Media/Hero%20Section%20Video%20WOv3.mp4",
    "https://realta.b-cdn.net/Media/Hero%20Section%20Fallback.jpg": "https://realta.b-cdn.net/Media/Hero%20Section%20Fallback%20WO.jpg"
  },
  "listing-media": {
    "https://realta.b-cdn.net/Media/WO%20Level%201%20Doug%20Gordin%20Whitby%2C%20Ontario.mp4": "https://realta.b-cdn.net/Media/WO%20Level%201%20-%20111%20Glenmore%20Rd%2C%20Toronto%2C%20ON%20M4L%203M2%20.mp4",
    "https://realta.b-cdn.net/Media/WO%20Leve%201%20-%20Example%201%20Fallback%20(1).jpg": "https://realta.b-cdn.net/Media/WO%20Level%201%20-%20111%20Glenmore%20Rd%2C%20Toronto%2C%20ON%20Fallback.jpg"
  }
};

const migrateContent = (data: any, pageId: string): any => {
  if (!data) return data;
  if (typeof data === 'string') {
    return URL_MIGRATIONS[pageId]?.[data] || data;
  }
  if (Array.isArray(data)) {
    return data.map(item => migrateContent(item, pageId));
  }
  if (typeof data === 'object') {
    const migrated: any = {};
    for (const key in data) {
      migrated[key] = migrateContent(data[key], pageId);
    }
    return migrated;
  }
  return data;
};

export const useSiteContent = (pageId: string) => {
  const [content, setContent] = useState<Record<string, any>>(SITE_DEFAULTS[pageId] || {});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const docRef = doc(db, 'siteContent', pageId);
    const unsubscribe = onSnapshot(docRef, (snapshot) => {
      if (snapshot.exists()) {
        setContent(migrateContent(snapshot.data(), pageId));
      } else {
        setContent(SITE_DEFAULTS[pageId] || {});
      }
      setLoading(false);
    }, (error) => {
      console.error(`Error fetching site content for ${pageId}:`, error);
      setContent(SITE_DEFAULTS[pageId] || {});
      setLoading(false);
    });

    // Listen for live preview updates from parent window
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'SITE_CONTENT_PREVIEW' && event.data.pageId === pageId) {
        setContent(migrateContent(event.data.content, pageId));
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      unsubscribe();
      window.removeEventListener('message', handleMessage);
    };
  }, [pageId]);

  return { content, loading };
};
